import { cn } from "@spz/ui/lib/utils";
import type { NumericCellProps } from "../types";
export const NumericCell: React.FC<NumericCellProps> = ({
  value,
  format,
  alignment = "left",
  className,
}) => {
  const formattedValue = new Intl.NumberFormat(undefined, format).format(value);

  return (
    <div
      className={cn(
        "font-base",
        alignment === "left" && "text-left",
        alignment === "center" && "text-center",
        alignment === "right" && "text-right",
        className,
      )}
    >
      {formattedValue}
    </div>
  );
};
